import {
  MarkdownFormat,
  WHATSAPP_FORMATS,
} from '../../components/kp-whatsapp-markdown-helper/kp-whatsapp-markdown-helper.model';

const PLACEHOLDER = 'texto';

interface FormatMatcher {
  regex: RegExp;
  openTag: string;
  closeTag: string;
}

function escapeHtml(text: string): string {
  const div = document.createElement('div');
  div.textContent = text;
  return div.innerHTML;
}

function escapeRegExp(text: string): string {
  return text.replaceAll(/[.*+?^${}()|[\]\\]/g, String.raw`\$&`);
}

function buildFormatMatcher(format: MarkdownFormat): FormatMatcher | null {
  const [openDelimiter, closeDelimiter] = format.syntax.split(PLACEHOLDER);
  const [openTag, closeTag] = format.result?.split(PLACEHOLDER) ?? [];

  if (!openDelimiter || !closeDelimiter || !openTag || !closeTag) {
    return null;
  }

  return {
    // `s` so a format spans a line break, the way WhatsApp renders it.
    regex: new RegExp(`${escapeRegExp(openDelimiter)}(.+?)${escapeRegExp(closeDelimiter)}`, 'gs'),
    openTag,
    closeTag,
  };
}

const FORMAT_MATCHERS: FormatMatcher[] = WHATSAPP_FORMATS.filter((format) => format.result)
  .map(buildFormatMatcher)
  .filter((matcher): matcher is FormatMatcher => matcher !== null);

export function parseWhatsAppMarkdown(text: string): string {
  const formatted = FORMAT_MATCHERS.reduce(
    (html, matcher) => html.replaceAll(matcher.regex, `${matcher.openTag}$1${matcher.closeTag}`),
    escapeHtml(text),
  );

  // The preview renders through `innerHTML`, so a line break needs a tag to survive.
  return formatted.replaceAll(/\r\n|\r|\n/g, '<br>');
}
